import React from 'react';
import {Path} from "../components/svg/components/path";
import {Svg} from "../components/svg/components/Svg";

export const ThreeDotsHorizontal = ({style,className}) => {

  const defaultStyle =  {width: 24, height: 24};
  const assignedStyle = Object.assign(defaultStyle,style);

  return <Svg style={assignedStyle} className={className}>
    <Path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6
    0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
  </Svg>
}
